<template>
  <vs-table :data="data">
    <template slot="header">
      <vs-row>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="12"
          vs-sm="12"
          vs-xs="12"
        >
          <div class="con-input-search vs-table--search">
            <input
              class="input-search vs-table--search-input"
              type="text"
              v-model="text"
              @keyup.enter="search()"
            />
            <vs-icon icon="search"></vs-icon>
          </div>
        </vs-col>
      </vs-row>
    </template>

    <template slot="thead">
      <th-sort :text="$t('user')" column="user_name" @sort="handleClickSort" />
      <th-sort :text="$t('email')" column="email" @sort="handleClickSort" />

      <vs-th v-for="(notification, i) in notifications" :key="i">
        {{ notification.notification_name }}
      </vs-th>
    </template>

    <template slot-scope="{ data }">
      <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
        <vs-td :style="{ width: '20vw' }" class="text-left">
          {{ data[indextr].user_name }}
        </vs-td>
        <vs-td :style="{ width: '20vw' }" class="text-left">
          {{ data[indextr].user_email }}
        </vs-td>

        <vs-td
          :style="{ width: '20vw' }"
          class="text-left"
          v-for="(notification, i) in data[indextr].notifications"
          :key="i"
        >
          <vs-switch
            success
            v-model="data[indextr].notifications[i].notification_status"
            @input="
              updateUser({
                user_id: data[indextr].user_id,
                notification_id: data[indextr].notifications[i].notification_id,
                notification_status:
                  data[indextr].notifications[i].notification_status,
              })
            "
          />
        </vs-td>
      </vs-tr>
      <vs-tr>
        <vs-td colspan="100%">
          <div v-if="data.length" v-observe-visibility="infiniteHandler"></div>
        </vs-td>
      </vs-tr>
    </template>
  </vs-table>
</template>

        <script>
import ThSort from '@/views/components/ThSort.vue'
import vSelect from 'vue-select'
export default {
  components: {
    ThSort,
    vSelect,
  },
  data() {
    return {
      text: '',
    }
  },
  methods: {
    handleClickSort(e) {
      if (this.data.length > 0) {
        this.$emit('sort', e)
      }
      return
    },
    infiniteHandler(isVisible) {
      if (!isVisible) {
        return
      }
      this.$emit('loadMore')
    },
    search() {
      this.$emit('search', this.text)
    },

    clear() {
      this.$emit('input', [])
    },
    updateUser (item) {
      this.$emit('updateUser', item)
    },
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    notifications: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style>
</style>
